// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#setAccount .setAccount-form .el-form-item--small.el-form-item {\n  margin: 0 auto 18px auto;\n}\n#setAccount .setAccount-form .el-textarea {\n  width: 440px;\n}\n#setAccount .setAccount-form .form-btn {\n  display: block;\n  margin-left: 0;\n  margin-top: 40px !important;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
